<script setup lang="ts">
import { mergeProps, useAttrs } from "vue";

/** Make-primary control and indicator: a filled star when [primary], otherwise an outlined star
 * that makes the row primary. [label] names the make-primary action; [primaryLabel] is shown
 * once the row is primary. */
defineOptions({ inheritAttrs: false });
withDefaults(
  defineProps<{
    primary?: boolean | null;
    label: string;
    primaryLabel?: string;
  }>(),
  { primaryLabel: "Primary" },
);
const attrs = useAttrs();
</script>

<template>
  <v-tooltip :text="primary ? primaryLabel : label" location="top">
    <template #activator="{ props: tooltipProps }">
      <v-btn
        v-bind="mergeProps(attrs, tooltipProps)"
        :color="primary ? 'amber-darken-2' : undefined"
        variant="text"
        density="comfortable"
        :icon="primary ? 'mdi-star' : 'mdi-star-outline'"
        :aria-label="label"
        :aria-pressed="!!primary"
      />
    </template>
  </v-tooltip>
</template>
